import React from "react";
import { C, LAYOUT } from "../constants/colors";

/**
 * Shared page title chrome — matches Schedule Planner section headers.
 */
export default function PageHeader({
  title,
  subtitle,
  icon,
  actions,
  banner,
  style = {},
}) {
  return (
    <div style={{ marginBottom: 20, ...style }}>
      <div style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 16,
        flexWrap: "wrap",
      }}>
        <div style={{ display: "flex", alignItems: "flex-start", gap: 12, minWidth: 0 }}>
          {icon ? (
            <div style={{
              width: 42,
              height: 42,
              borderRadius: LAYOUT.radiusSm,
              background: C.primarySoft,
              border: `1px solid ${C.primary}22`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              color: C.primary,
              fontSize: 18,
              fontWeight: 600,
            }}>
              {icon}
            </div>
          ) : null}
          <div style={{ minWidth: 0 }}>
            <h1 style={{
              margin: 0,
              fontSize: 22,
              fontWeight: 700,
              color: C.text,
              letterSpacing: "-0.02em",
              lineHeight: 1.2,
            }}>
              {title}
            </h1>
            {subtitle ? (
              <p style={{
                margin: "6px 0 0",
                fontSize: 14,
                color: C.muted,
                lineHeight: 1.45,
                maxWidth: 640,
              }}>
                {subtitle}
              </p>
            ) : null}
          </div>
        </div>
        {actions ? (
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
            {actions}
          </div>
        ) : null}
      </div>
      {banner ? (
        <div style={{
          marginTop: 14,
          padding: "10px 14px",
          borderRadius: LAYOUT.radiusSm,
          background: C.primarySoft,
          border: `1px solid ${C.primary}22`,
          color: C.primaryDark,
          fontSize: 14,
          lineHeight: 1.5,
        }}>
          {banner}
        </div>
      ) : null}
    </div>
  );
}
